import { render } from "./StatisticheCaricamenti.vue?vue&type=template&id=2a44c4ba&scoped=true"
import script from "./StatisticheCaricamenti.vue?vue&type=script&lang=js"
export * from "./StatisticheCaricamenti.vue?vue&type=script&lang=js"

import "./StatisticheCaricamenti.vue?vue&type=style&index=0&id=2a44c4ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a44c4ba"]])

export default __exports__